import { render } from "./WorkflowDefinitions.vue?vue&type=template&id=4b59e10c"
import script from "./WorkflowDefinitions.vue?vue&type=script&lang=js"
export * from "./WorkflowDefinitions.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__